import { formatMoney } from '../../utils/currency';

const switchStockDisplay = (options: Record<string, any>) => ((availablilityFlag: string, price: number) : void => {
  const purchasable = availablilityFlag === 'available' || availablilityFlag === 'pre-order' || availablilityFlag === 'low'
  const {stockWrapper, stockWrapperAttr, atcButton, oosAttr, inStockAttr, unavailableAttr, preOrderAttr} = options;
  atcButton.disabled = !purchasable;
  stockWrapper.setAttribute(stockWrapperAttr, availablilityFlag)
  atcButton.classList.remove('hide');
  if (availablilityFlag === 'pre-order') {
    atcButton.classList.add('btn-tertiary')
    atcButton.classList.remove('btn-tertiary')
  } else {
    atcButton.classList.add('btn-tertiary')
    atcButton.classList.remove('btn-tertiary')
  }
  if (availablilityFlag === 'pre-order') {
    atcButton.innerHTML = atcButton.getAttribute(preOrderAttr)
  } else if (availablilityFlag === 'available' || availablilityFlag === 'low') {
    atcButton.innerHTML = `${atcButton.getAttribute(inStockAttr)} (<span data-product-qty-price>${formatMoney(price, window['theme'].moneyFormat)}</span>)`;
  } else if (availablilityFlag === 'oos') {
    atcButton.classList.add('hide');
    atcButton.innerHTML = atcButton.getAttribute(oosAttr)
  } else {
    // unavailable - ie variant does not exist
    atcButton.innerHTML = atcButton.getAttribute(unavailableAttr)
  }
})
export default switchStockDisplay